import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, Input } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { FC, useEffect, useState } from "react";

type Props = {
  onClose: () => void;
  open: boolean;
  onSearch: (searchString: string) => void;
};

const SearchUserDialog: FC<Props> = ({
  onClose,
  open,
  onSearch
}) => {
  const [searchString, setSearchString] = useState<string>("");

  useEffect(() => {
    setSearchString("");
  }
  , [open]);

  const handleSearch = (string: string) => {
    onSearch(string);
    onClose();
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(_event, data) => !data.open && onClose()}
      modalType="alert"
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle            
          action={
            <Button
              appearance="subtle"
              shape="circular"
              aria-label="close"
              icon={<DismissRegular />}
              onClick={onClose}
            />
          }>Sök användare</DialogTitle>
          <DialogContent>
            <Field 
              label="Skriv önskat sökord"
              hint="E-post, titel, för- & efternamn, avdelning, behörighet m.m."
            >
              <Input 
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
              />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Avbryt</Button>
            <Button 
              appearance="primary" 
              onClick={() => handleSearch(searchString)}
            >
              Sök
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>)
}

export default SearchUserDialog;